const allowedParentDomainsStr = process.env.REACT_APP_ALLOWED_PARENT_DOMAINS;

/**
 * @memberof module:util
 * @function
 * @name checkParentOrigins
 * @description Check whether origin in incoming message from parent website should be allowed or not.
 *
 * @param {string} origin - origin in incoming message
 * @returns {boolean}
 *
 * @example
 * console.log(checkParentOrigins("https://google.com")); //false, means this origin's incoming message is NOT allowed.
 * console.log(checkParentOrigins("https://primefreight.com")); //true, means this origin's incoming message is allowed.
 */
export const checkParentOrigins = (origin) => {
  const domainsArr = getAllowedParentDomainsArr();

  // console.log({ domainsArr, check: domainsArr.indexOf(`${origin}`) !== -1 });

  return domainsArr.indexOf(`${sanitizeOrigin(origin)}`) !== -1;
};

const sanitizeOrigin = (origin) => {
  return origin.replace(/\/+$/, '');
};

/**
 * @memberof module:util
 * @function
 * @name getAllowedParentDomainsArr
 * @description Get all the allowed parent website origins. Only these origins can send/receive message to/from this ratesearch web app.
 *
 * @returns {Array}
 *
 * @example
 * console.log(getAllowedParentDomainsArr()); //["https://domain-one.com", "https://primefreight.com"]
 */

export const getAllowedParentDomainsArr = () => {
  let domainsArr = [];
  domainsArr =
    (allowedParentDomainsStr && allowedParentDomainsStr.split(',')) || [];
  domainsArr = domainsArr.map((domain) => {
    const tempDomain = domain.trim();
    return sanitizeOrigin(tempDomain);
  });

  return domainsArr;
};
